<template>
<footer class="gbpro-footer">
  <div class="gbpro-footer__inner">
    <p class="gbpro-footer__copy">
&copy; 2026 <a href="/">
gbwhatspro.chat
</a>. Informational guides and APK access for Android users.
</p>
    <nav class="gbpro-footer__nav" aria-label="Footer">
      <template v-for="(item, index) in footerItems">
        <span v-if="index > 0" :key="`${item.path}-sep`" class="gbpro-footer__sep" aria-hidden="true">|</span>
        <a :key="item.path" :href="item.path">
{{ item.label }}
</a>
      </template>
    </nav>
  </div>
</footer>
</template>

<script>
import { footerItems } from '@/data/gbwhatsproPages'

export default {
  name: 'SiteFooter',
  data() {
    return {
      footerItems,
    }
  },
}
</script>

<style lang="scss" scoped>
.gbpro-footer {
	background: var(--gb-bg);
	border-top: 1px solid var(--gb-line);
	color: var(--gb-muted);
	padding: 20px var(--gb-page-x) 22px;
}

.gbpro-footer__inner {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	width: 100%;
	max-width: none;
	margin: 0 auto;
	text-align: center;
}

.gbpro-footer__copy {
	margin: 0;
	color: var(--gb-muted);
	font-size: 0.84rem;
	line-height: 1.65;

	a {
		color: var(--gb-green-bright);
		font-weight: 700;
	}
}

.gbpro-footer__nav {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	gap: 0;
	font-size: 0.76rem;
	line-height: 1.5;

	a {
		color: var(--gb-green-bright);
		font-weight: 700;
	}
}

.gbpro-footer__sep {
	margin: 0 0.65em;
	color: rgba(255, 255, 255, 0.22);
	font-weight: 400;
	user-select: none;
}
</style>
